import { KrCard } from '@/common/card/KrCard';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { McoFinTrendChart } from './McoFinTrendChart';

export const PaidTrendsCard = ({ formValues, idToProgType }) => {
  const [isChart, setIsChart] = useNavStateSync('paidTrendIsChart', true);

  const paidTrendButtons = (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={isChart}
      sx={{ width: 'fit-content' }}
      onChange={(event, value) => {
        setIsChart(value);
      }}
    >
      <ToggleButton value={true} aria-label="bold">
        Chart
      </ToggleButton>
      <ToggleButton value={false} aria-label="bold">
        Table
      </ToggleButton>
    </ToggleButtonGroup>
  );

  return (
    <KrCard title="Quarter Over Quarter Paid Trends" buttons={paidTrendButtons}>
      <McoFinTrendChart formValues={formValues} idToProgType={idToProgType} isPaid={true} isChart={isChart} />
    </KrCard>
  );
};
